__turbopack_context__.v({
  "bottomMenu": "_6XT_1G_bottomMenu",
});
